import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const whatsappAPI = createApi({
  reducerPath: "whatsappAPI",
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.sysigreja.com/api" }),
  tagTypes: ["Token", "Session"],
  endpoints: () => ({}),
});
